import { z } from "zod"

const analysisId = z.string().regex(/^[A-Za-z0-9_-]{1,128}$/)
const common = { analysis_id: analysisId }
export const audioAnalysisSnapshotSchema = z.discriminatedUnion("status", [
  z.object({ ...common, status: z.literal("queued") }),
  z.object({ ...common, status: z.literal("running") }),
  z
    .object({
      ...common,
      status: z.literal("succeeded"),
      output_type: z.enum(["number", "boolean"]),
      value: z.union([z.number().finite(), z.boolean()]),
      explanation: z.string().max(2048).optional(),
    })
    .refine((s) =>
      s.output_type === "boolean"
        ? typeof s.value === "boolean"
        : typeof s.value === "number",
    ),
  z.object({
    ...common,
    status: z.literal("failed"),
    message: z.string().max(512).optional(),
  }),
  z.object({
    ...common,
    status: z.literal("unavailable"),
    message: z.string().max(512).optional(),
  }),
])

/** App-owned presentation projection; never retains bearer receipts or Python source. */
export type AudioAnalysisSnapshot = z.infer<typeof audioAnalysisSnapshotSchema>

export interface AudioAnalysisItem {
  kind: "analysis"
  id: string
  analysis: AudioAnalysisSnapshot
  firstSeenAt: number
  provisional?: boolean
}
